import { createFileRoute } from "@tanstack/react-router";
import { PurchaseEditor } from "~/features/purchasing/editor";
import { PurchasingBackLink } from "~/features/purchasing/model";

export const Route = createFileRoute("/_app/purchasing/new")({ component: NewPurchaseOrder });

function NewPurchaseOrder() {
  return <PurchaseEditor back={<PurchasingBackLink />} />;
}
